export const giftsMapping = [
  {
    id: 0,
    name: "RV/Camper Van Rental Fund",
    description:
      "help contributie to our RV/campervan rental as We travel across the north and South island of New Zeeland.",
    cost: "Open",
    image: process.env.PUBLIC_URL + "assets/Gifts/0.jpg",
    purchased: false,
  },
  {
    id: 1,
    name: "Gas Money",
    description:
      "Goal: 3710km (2306 miles) – partial contribution accepted as well!",
    cost: "100kr/10USD = 40km (25 miles) 250kr/25USD = 105km (65 miles) 500kr/50 USD = 200km (125 miles)",
    image: process.env.PUBLIC_URL + "assets/Gifts/1.jpg",
    purchased: false,
  },
  {
    id: 2,
    name: "Ferry to South with Interislander",
    description:
      "To travel between the north island and the south island, we need to take a ferry with our RV",
    cost: "500USD",
    image: process.env.PUBLIC_URL + "assets/Gifts/2.jpg",
    purchased: false,
  },
  {
    id: 3,
    name: "Hotel night in Auckland",
    description:
      "We fly in to Auckland and will spend our first night in a hotel before we get our campervan and take off!",
    cost: "120USD",
    image: process.env.PUBLIC_URL + "assets/Gifts/3.jpg",
    purchased: true,
  },
  {
    id: 22,
    name: "Hotel night in Queenstown",
    description: "We fly back to the States from Queenstown and want to spend our last night in a hotel before our flight departs.",
    cost: "120USD",
    image: process.env.PUBLIC_URL + "assets/Gifts/22.jpg",
    purchased: true,
  },
  {
    id: 4,
    name: "Blackwater rafting in Waitomo Caves",
    description:
      "New Zealand’s maximum-adrenaline Black Water Rafting tour. we will  abseil to the depths of the earth, zip line through a glow worm studded cave, climb underground waterfalls and tube through fast-flowing waters.",
    cost: "150USD per person (300 for Fanny and Nate)",
    image: process.env.PUBLIC_URL + "assets/Gifts/4.jpg",
    purchased: true,
  },
  {
    id: 5,
    name: "KAITUNA RIVER WHITE WATER RAFTING IN ROTORUA NEW ZEALAND",
    description:
      "Experience the adrenaline of white water rafting on Kaituna River! Raft the highest commercially rafted waterfall in the world! The Kaituna River is Rotorua Rafting’s playground, with an all-Kiwi crew and home to not just one, but three impressive waterfalls, including the highest rafted waterfall in the world – Tutea Falls at 7m, Okere Falls and Kaituna Falls. There is no denying that there is something amazing about this trip! The Kaituna river has been ranked as the best white water rafting in the world due to the kind nature of the river mixed with hair-raising waterfalls. It enables us to provide a tailored rafting tour to match your adrenalin needs, whether it’s rafting your grandma or a full-blown adrenalin junkie. We will give them the trip they desire.",
    cost: "60USD per person (120USD for Fanny and Nate)",
    image: process.env.PUBLIC_URL + "assets/Gifts/5.jpg",
    purchased: true,
  },
  {
    id: 6,
    name: "Lake Tapo boat tour craving",
    description:
      "On board a charter yacht, the Kindred Spirit, sail on Lake Taupo, admiring the mountain views. Sail to the Maori Rock Carvings, which can only be seen from the water. If the weather’s good you can swim, or simply sit on the deck and relax with a blanket to keep you warm.",
    cost: "35USD per person (70USD for Fanny and Nate)",
    image: process.env.PUBLIC_URL + "assets/Gifts/6.jpg",
    purchased: false,
  },
  {
    id: 7,
    name: "Warekri terras and Thermal spa",
    description:
      "The regions only geothermal and silica bathing experience At Wairakei Terraces, our pools draw their healing properties from silica terraces and geothermal water flow from 1.5 kilometres underground delivering an unbeatable combination of geothermal and mineral water. Immerse yourself in the mineral rich, hot thermal pools, at the bottom of silica terraces and instantly feel the silky smoothness on your skin and the warmth across your body. ​ Let the days worries drift away and be replaced with the luxurious embrace of natural heat.",
    cost: "27USD per person (54USD for Fanny and Nate)",
    image: process.env.PUBLIC_URL + "assets/Gifts/7.jpg",
    purchased: true,
  },
  {
    id: 8,
    name: "Abel Tasman national park (cruise and hiking exkursion)",
    description:
      "Discover the jewel in the crown of New Zealand’s South Island on this full-day Abel Tasman National Park hiking tour with cruise. Travel from Nelson to Kaiteriteri with your guide, then hop aboard your water taxi. Cruise the azure-blue seas toward the heart of Abel Tasman National Park and the start-point of your trek. Follow hiking trails through the dense forest and listen as your guide points out medicinal and edible plants along the way. Gain insight into native Maori and Dutch settlers’ heritage, and enjoy lunch on Torrent Beach",
    cost: "70USD per person (120USD for Fanny and Nate)",
    image: process.env.PUBLIC_URL + "assets/Gifts/8.jpg",
    purchased: true,
  },
  {
    id: 9,
    name: "Bike and wine: Marlborough wine region",
    description:
      "Marlborough wine region is located in the north of the South Island of New Zealand. It's well known for its winemaking industry, and for the Marlborough Sounds, an extensive network of coastal waterways, peninsulas, and islands. Early settlers in Marlborough planted vines as early as the 1870s. One day bike rental for Fanny and Nate to bike from winery to wienry adn dsicover this beautiful region.  Based at the Vines Village there are over a dozen wineries, 3km of your starting point. Bike Hire includes a bike, helmet, a bike lock, map.",
    cost: "35USD per person (70usd for Fanny and Nate)",
    image: process.env.PUBLIC_URL + "assets/Gifts/9.jpg",
    purchased: true,
  },
  {
    id: 10,
    name: "Bottle of wine from the Marborough wine region",
    description:
      "Buy us a bottle of wine from one of the many wineries in the Marborough wine region. The Marlborough wine region is by far New Zealand's largest, accounting for three quarters of the country's wine production, 70% of its vineyard area and 85% of its wine exports. Internationally, Marlborough Sauvignon Blanc is recognised as world class",
    cost: "20USD for one wine bottle",
    image: process.env.PUBLIC_URL + "assets/Gifts/10.jpg",
    purchased: false,
  },
  {
    id: 11,
    name: "Kaikoura whale watching",
    description:
      "Experience the natural treasures of New Zealand on a Kaikoura whale-watching cruise. Look for impressive sperm whales along with migrating humpbacks and southern right whales, and search the waters for orcas and other dolphins as an experienced guide shares informative commentary",
    cost: "200USD for Fanny and Nate",
    image: process.env.PUBLIC_URL + "assets/Gifts/11.jpg",
    purchased: true,
  },
  {
    id: 12,
    name: "Christchurch gondola",
    description:
      "An unmissable Christchurch experience, the Gondola offers stunning panoramic views of the city, Lyttelton Harbour, and beyond. Gaze at the snow-capped Southern Alps, sprawling Canterbury Plains and the sparkling waters of Pegasus Bay and the Pacific Ocean. A great spot to explore.",
    cost: "46USD for Fanny and Nate",
    image: process.env.PUBLIC_URL + "assets/Gifts/12.jpg",
    purchased: true,
  },
  {
    id: 13,
    name: "Helicopter to Tasman Glacier and Hike",
    description:
      "Nate, a pilot, has actually never flown an helicopter! Combine the excitement of walking on New Zealand’s biggest glacier, the Tasman Glacier, with the thrill of breathtaking scenic helicopter flight and spectacular views of New Zealand’s highest mountain, Aoraki Mt Cook. You will fly in to your drop off point on a remote part of the glacier. Once your crampons or snowshoes are fitted you’ll go exploring the amazing ice formations, following your guide as they cut steps in the glacier, using skills handed down from NZ’s mountain pioneers.",
    cost: "400USD per person (800USD for Fanny and Nate)",
    image: process.env.PUBLIC_URL + "assets/Gifts/13.jpg",
    purchased: false,
  },
  {
    id: 14,
    name: "Milford sound cruise and Kayaking",
    description:
      "Deep within Fiordland National Park lies Milford Sound, New Zealand’s most stunning natural attraction. With its magical combination of mountain peaks, ink-dark waters and superb dramatic forest-clad cliffs, it must be seen to be believed. Double the adventure with our Milford Sound Cruise & Kayak experience. This trip includes a Milford Sound cruise, a visit to the Milford Sound Underwater Observatory and up to 90 minutes of kayaking around sheltered Harrison Cove",
    cost: "170USD per person and 340USD for Fanny and Nate",
    image: process.env.PUBLIC_URL + "assets/Gifts/14.jpg",
    purchased: true,
  },
  {
    id: 15,
    name: "Bungee jumping Queenstown",
    description:
      "Fanny has always dreamed about going bungee jumping. Nate will take all the pictures and videos of her doing it. Nevis bungee is a 134m bungee (the highest in New Zealand). It’s 8.5 seconds in a blitz of pure fear and adrenaline. ",
    cost: "170USD for Fanny",
    image: process.env.PUBLIC_URL + "assets/Gifts/15.jpg",
    purchased: true,
  },
  {
    id: 16,
    name: "Queenstown mountain biking",
    description:
      "The Skyline Gondola takes the hard work out of mountain biking by depositing riders and bikes almost 500 metres above central Queenstown. After the super-scenic, six-minute ride up, the downhill options are mind-boggling, with 28 world-class trails crisscrossing the southern flanks of Bob’s Peak. As befitting one of the world’s most popular adrenaline sport resorts, the 30+ km trail network winds, drops, swoops and flies through exotic and regenerating native forest with eye-popping views across Lake Wakatipu to the jagged Remarkable and Cecil Peak. Day Bike rental for Fanny and Nate",
    cost: "70USD for Fanny and Nate",
    image: process.env.PUBLIC_URL + "assets/Gifts/16.jpg",
    purchased: true,
  },
  {
    id: 17,
    name: "Queenstown skyline gondola and hike",
    description:
      "Take a scenic ride in the iconic Skyline Gondola and take in the stunning views as you ride the steepest cable car lift in the Southern Hemisphere! You’ll be carried 480 metres above Queenstown and Lake Wakatipu to the top of Bob's Peak, where you’ll enjoy a spectacular 220-degree panorama with breath-taking views of Coronet Peak, The Remarkables, Walter and Cecil Peak and, of course, Queenstown. When you get to the top, enjoy the spectacular views while having a drink from the Bar, take a few rides on the thrilling Luge (once is never enough), refuel with a sumptuous buffet lunch or dinner at Stratosfare Restaurant. There's more to enjoy!",
    cost: "40 USD per person (80USD for Fanny and Nate)",
    image: process.env.PUBLIC_URL + "assets/Gifts/17.jpg",
    purchased: false,
  },
  {
    id: 18,
    name: "Quuenstown Skyline Luge",
    description:
      "At the top of queenstown, after taking the gonodla, there is the gravity-fuelled Skyline Luge, the global thrill ride.  Luge carts puts us in complete control as you take on over 1,600 metres of banked corners, tunnels and dippersall the way down to the city",
    cost: "42 Usd per person  (84USD for Fanny and Nate)",
    image: process.env.PUBLIC_URL + "assets/Gifts/18.jpg",
    purchased: false,
  },
  {
    id: 19,
    name: "Romantic dinner for 2",
    description:
      "A romantic dinner for two along our trip from north to south island in New Zealand. Let us splurge at a nice restaurant between the campsite and road trip food. Auckland, Queenstown, or any small towns we pass have delicious and special dinner experiences we would love to try out",
    cost: "60USD for dinner for two",
    image: process.env.PUBLIC_URL + "assets/Gifts/19.jpg",
    purchased: false,
  },
  {
    id: 20,
    name: "Nate’s beer fund",
    description: "Help fund Nate's beer fund as he travels through New Zealand and discover brewery after brewery.",
    cost: "Open",
    image: process.env.PUBLIC_URL + "assets/Gifts/20.jpg",
    purchased: false,
  },
  {
    id: 21,
    name: "Fanny’s wine fund",
    description: "Help fund Fanny's wine fund as she travels through New Zealand and discover winery after winery",
    cost: "Open",
    image: process.env.PUBLIC_URL + "assets/Gifts/21.jpg",
    purchased: false,
  },
];